import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import useLocalization from '../../../hooks/useLocalization';
import SwipeableModalShell from '../../atoms/SwipeableModalShell';
import FinpspPaymentInstructions from './FinpspPaymentInstructions';

const styles = {
  root: {
    position: 'relative',
    p: { xs: 2.5, md: 3 },
    maxHeight: '85dvh',
    boxSizing: 'border-box',
  },
  closeButton: {
    position: 'absolute',
    top: 2,
    right: 2,
    display: { xs: 'none', md: 'inline-flex' },
    color: 'neutral.25',
    minWidth: 44,
    minHeight: 44,
  },
};

type FinpspPaymentDialogProps = {
  transactionId: string;
  onClose: () => void;
};

const FinpspPaymentDialog = ({ transactionId, onClose }: FinpspPaymentDialogProps) => {
  const { t } = useLocalization();

  return (
    <SwipeableModalShell sx={styles.root}>
      <IconButton aria-label={t('close')} onClick={onClose} sx={styles.closeButton}>
        <CloseIcon />
      </IconButton>
      <SwipeableModalShell.ScrollArea>
        <FinpspPaymentInstructions transactionId={transactionId} />
      </SwipeableModalShell.ScrollArea>
    </SwipeableModalShell>
  );
};

export default FinpspPaymentDialog;
